<template>
  <div
    class="confirm-debit"
    @click="emitCloseConfirm"
  >
    <popup-base @clickOnBackground="emitCloseConfirm">
      <div
        class="confirm-debit bg-white m-auto w-1/2 p-5 rounded"
      >
        <div class="mt-6">
          <h3 class="tracking-widest text-2xl leading-10 confirm-text font-normal  ">
            {{ $t('wantToBackText') }}
          </h3>
        </div>
        <div class="action-button-section justify-between  flex mt-6">
          <div
            class="flex-one w-1/2 text-center p-1 cancel-button cursor-pointer m-1"
            @click="emitCancelCreate"
          >
            <button class=" px-2 cancel py-4 text-center font-bold uppercase">
              {{ $t('wantToBackCancel') }}
            </button>
          </div>
          <div
            class="flex-one w-1/2 bg-red cursor-pointer flex items-center justify-center rounded p-1 text-center m-1"
            @click="emitSaveCreate"
          >
            <button class=" px-2  py-4 text-center text-white  font-bold uppercase ">
              {{ $t('wantToBackClose') }}
            </button>
          </div>
        </div>
      </div>
    </popup-base>
  </div>
</template>

<script>
import PopupBase from './popup-base'
export default {
  name: 'WantToBack',
  components: { PopupBase },
  props: {
    amount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    emitCancelCreate () {
      this.$emit('emitCancelSave', false)
    },
    emitSaveCreate () {
      this.$emit('emitSaveBefore', false)
    },
    emitCloseConfirm () {
      this.$emit('emitCloseWantToBack', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
  .amount-section {
    background: $Rema-Icon-Background;
  }
  .cancel {
    color: #BCBCBC;
  }
  .confirm-text {
    line-height: 2.3rem;
  }
</style>
